import React from 'react'

export default function Button() {
  return (
    <>
      <h1>Button</h1>
      <p><span className='tag-grey bold'>.button</span> class or html tag: <code> &lt;button"&gt;</code> will activate the styling for button </p>
      <p>There are two types of buttons: Default and Outline</p>
    
      <h2 className='mb-0'>Default Buttons:</h2>
      <h3>Code :</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;button class="button"&gt; a Button&lt;/button&gt;<br/>
            &lt;button class="button button-dark"&gt; a Button&lt;/button&gt;<br/>
            &lt;button class="button button-dgrey"&gt; a Button&lt;/button&gt;<br/>
            &lt;button class="button button-blue"&gt; a Button&lt;/button&gt;<br/>
            &lt;button class="button button-green"&gt; a Button&lt;/button&gt;<br/>
            &lt;button class="button button-red"&gt; a Button&lt;/button&gt;<br/>
            &lt;button class="button button-grey"&gt; a Button&lt;/button&gt;<br/>
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve flex-align-xy'>
        <button className="button"> a Button</button>
        <button className="button button-dark"> a Button</button>
        <button className="button button-dgrey"> a Button</button>
        <button className="button button-blue"> a Button</button>
        <button className="button button-green"> a Button</button>
        <button className="button button-red"> a Button</button>
        <button className="button button-grey"> a Button</button>
      </div>

      <h2 className='mt-4'>Outline Buttons:</h2>
      <h3>Code :</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;a class="button button-o-dark"&gt; a Button&lt;/a&gt;<br/>
            &lt;a class="button button-o-dgrey"&gt; a Button&lt;/a&gt;<br/>
            &lt;a class="button button-o-blue"&gt; a Button&lt;/a&gt;<br/>
            &lt;a class="button button-o-green"&gt; a Button&lt;/a&gt;<br/>
            &lt;a class="button button-o-red"&gt; a Button&lt;/a&gt;<br/>
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve flex-align-xy'>
        <a href='/button' className="button button-o-dark"> a Button</a>
        <a href='/button' className="button button-o-dgrey"> a Button</a>
        <a href='/button' className="button button-o-blue"> a Button</a>
        <a href='/button' className="button button-o-green"> a Button</a>
        <a href='/button' className="button button-o-red"> a Button</a>
      </div>
    </>
  )
}
